module.exports = __webpack_public_path__ + "img/exit.bbbf1509.svg";